import { Injectable } from '@angular/core';
import {Page} from "./api.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {Room} from "./room.service";
import {SimpleUser} from "./user.service";

export type GroupingStrategy = 'RANDOM' | 'SIMILAR_SCORES' | 'DIVERSE_SCORES' ;
export type GroupStatus = 'ACTIVE' | 'COMPLETED' | 'DELETED' ;

export class Group {

  id?: string ;
  roomId?: string ;
  index?: number;
  members: SimpleUser[] ;
  status: GroupStatus;

  constructor(members: SimpleUser[]) {
    this.members = members ;
    this.status = 'ACTIVE' ;
  }

}

export interface GroupmateSummary {
  id: string ;
  user: SimpleUser ;
  count: number ;
  lastGroupedAt: Date ;
  tags: string[] ;
}

export class GroupQuery {
  tags: string[] = [];
  memberId?: string ;
  status?: GroupStatus;
}

export class BulkGroupEdit {

  modified: Group[] = [] ;
  deleted: Group[] = [] ;
  added: Group[] = [] ;

}


@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(
    private http: HttpClient
  ) { }

  getCurrentGroups(roomId: string, page: number): Observable<Page<Group>> {

    const query = new GroupQuery();
    query.status = 'ACTIVE' ;

    let params = {
      page: (page) ? page : 0,
      q: JSON.stringify(query)
    }

    return this.http.get(
      `${environment.apiHost}/rooms/${roomId}/groups`,
      { params }
    ) as Observable<Page<Group>>;
  }

  getMyGroup(roomId: string): Observable<Group> {

    return this.http.get(
      `${environment.apiHost}/rooms/${roomId}/groups/mine`
    ) as Observable<Group>;
  }

  editGroups(roomId: string, edit:BulkGroupEdit): Observable<Group[]> {

    return this.http.post(
      `${environment.apiHost}/rooms/${roomId}/group-edits`,
      edit
    ) as Observable<Group[]>;
  }


  /*
  formGroups(roomId: string, count: number, strategy:GroupingStrategy): Observable<Room> {
    return this.http.post(
      `${environment.apiHost}/rooms/${roomId}/actions`,
      {
        type: 'FORM_GROUPS',
        count: count,
        strategy: strategy
      }
    ) as Observable<Room>;
  }

  disbandGroups(roomId: string): Observable<Room> {
    return this.http.post(
      `${environment.apiHost}/rooms/${roomId}/actions`,
      {
        type: 'DISBAND_GROUPS'
      }
    ) as Observable<Room>;
  }*/

  getGroupmates(query: GroupQuery, page:number): Observable<Page<GroupmateSummary>> {

    let params = {
      q: JSON.stringify(query),
      page: (page) ? page : 0
    }

    return this.http.get(
      `${environment.apiHost}/groupmates`,
      {params}
    ) as Observable<Page<GroupmateSummary>>;
  }

  getGroups(roomId:string, query:GroupQuery, page: number) {
    let params = {
      page: (page) ? page : 0,
      q: JSON.stringify(query)
    }

    return this.http.get(
      `${environment.apiHost}/rooms/${roomId}/groups`,
      { params }
    ) as Observable<Page<Group>>;
  }
}
